import React from 'react';

// Trustpilot's official logo (green star + wordmark), self-hosted from the Trustpilot Brand Hub
// at /public/images/trustpilot/trustpilot-logo.svg. Required by the Brand Guidelines whenever the Star
// Rating / TrustScore is displayed.
export function TrustpilotLogo() {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- self-hosted brand SVG, not optimizable
    <img src="/images/trustpilot/trustpilot-logo.svg" alt="Trustpilot" width={81} height={20} />
  );
}
